<div class="mt-5 overflow-auto centered">
    <h6 style="text-align: center;">
        Per eventuali segnalazioni di tipo tecnico contattare <b>roadmap@cri.it</b>
    </h6>

    <accordion>
        <accordion-group heading="Anagrafica"
                         [isOpen]="true">
            <div>

                <p>Nome: <b>{{authService.getAuthenticatedUser().name}}</b></p>
                <p>Cognome: <b>{{authService.getAuthenticatedUser().surname}}</b></p>
                <p>Email: <b>{{authService.getAuthenticatedUser().email}}</b></p>
                <p>Codice fiscale: <b>{{authService.getAuthenticatedUser().cod_fiscale}}</b></p>
                <p>Sesso: <b>{{authService.getAuthenticatedUser().sex}}</b></p>
                <!--<p>Luogo di nascita: <b>{{authService.getAuthenticatedUser().birth_place}}</b></p>
          <p>Luogo di residenza: <b>{{authService.getAuthenticatedUser().residence_place}}</b></p>-->

            </div>
        </accordion-group>
        <accordion-group heading="Luogo di residenza" class="mt-3"
                         [isOpen]="false">
            <div>
                <p>Indirizzo: <b>{{authService.getAuthenticatedUser().residence.address}}</b></p>
                <p>CAP: <b>{{authService.getAuthenticatedUser().residence.postal_code}}</b></p>
                <p>Città: <b>{{authService.getAuthenticatedUser().residence.city.name}}</b></p>
                <p>Provincia: <b>{{authService.getAuthenticatedUser().residence.city.province}}</b></p>
                <p>Regione: <b>{{authService.getAuthenticatedUser().residence.city.region}}</b></p>
                <p>Nazione: <b>{{authService.getAuthenticatedUser().residence.city.nation.code}}</b></p>

            </div>
        </accordion-group>
    </accordion>
    <div class="mt-3">
        <button type="button" class="btn btn-outline-primary float-right" (click)="logOut()"> LOGOUT </button>
    </div>
</div>
